/* LT Club: botón para pausar el vídeo de portada (accesibilidad) */
(() => {
  function heroPause() {
    document.querySelectorAll('.slideshow-section video.slide__video').forEach((video) => {
      const slide = video.closest('slideshow-slide') || video.parentElement;
      if (!slide || slide.querySelector('.lt-video-toggle')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'lt-video-toggle';
      const sync = () => {
        const paused = video.paused;
        button.setAttribute('aria-label', paused ? 'Reproducir vídeo' : 'Pausar vídeo');
        button.setAttribute('aria-pressed', String(paused));
        button.innerHTML = paused
          ? '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M3 1.5v11l9-5.5z" fill="currentColor"/></svg>'
          : '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M3 1.5h3v11H3zM8 1.5h3v11H8z" fill="currentColor"/></svg>';
      };
      button.addEventListener('click', () => {
        if (video.paused) { video.dataset.ltUserPaused = ''; video.play().catch(() => {}); }
        else { video.dataset.ltUserPaused = '1'; video.pause(); }
      });
      video.addEventListener('play', () => { if (video.dataset.ltUserPaused === '1') video.pause(); sync(); });
      video.addEventListener('pause', sync);
      sync();
      slide.appendChild(button);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', heroPause);
  else heroPause();
  document.addEventListener('shopify:section:load', heroPause);
})();

/* LT Club: la cinta de avisos no se anuncia una y otra vez en lectores de pantalla */
(() => {
  const quiet = () => document.querySelectorAll('.announcement-bar [aria-live], .announcement-bar[aria-live]').forEach((el) => el.removeAttribute('aria-live'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', quiet);
  else quiet();
})();

/* LT Club: las tarjetas de producto se ven al momento, sin esperar a la animación de scroll */
(() => {
  const show = () => document.querySelectorAll('#MainContent product-card.lt-reveal').forEach((el) => el.classList.remove('lt-reveal'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', show);
  else show();
})();

/* LT Club: en la ficha no hay talla preseleccionada; el botón pide «Elige tu talla» hasta que eliges */
(() => {
  const LABEL = 'Elige tu talla';
  function setup() {
    if (!/\/products\//.test(location.pathname)) return;
    const main = document.querySelector('#MainContent');
    if (!main) return;
    const fieldset = [...main.querySelectorAll('fieldset')].find((f) => !f.closest('dialog') && /^\s*talla/i.test(f.querySelector('legend')?.textContent || ''));
    if (!fieldset || fieldset.dataset.ltChoose) return;
    const radios = [...fieldset.querySelectorAll('input[type=radio]')];
    if (radios.filter((r) => r.dataset.optionAvailable !== 'false').length < 2) return;
    fieldset.dataset.ltChoose = 'pending';
    radios.forEach((r) => { r.checked = false; });
    main.querySelectorAll('.lt-delivery__low').forEach((el) => { el.hidden = true; });
    const buttons = () => [...main.querySelectorAll('button[name=add]'), ...document.querySelectorAll('.sticky-add-to-cart__button')].filter((b) => !b.closest('dialog'));
    // solo se cambia el nodo de texto: el contador de cantidad de la barra fija (ref quantityDisplay) tiene que seguir ahí
    const textNode = (b) => {
      const walker = document.createTreeWalker(b.querySelector('.add-to-cart-text') || b, NodeFilter.SHOW_TEXT, {
        acceptNode: (n) => {
          const inner = n.parentElement.closest('[ref], .add-to-cart__added');
          return n.textContent.trim() && (!inner || inner === b || !b.contains(inner)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        },
      });
      return walker.nextNode();
    };
    const label = () => {
      if (fieldset.dataset.ltChoose !== 'pending') return;
      buttons().forEach((b) => {
        const t = textNode(b);
        if (t && t.textContent.trim() !== LABEL) { b.dataset.ltText = t.textContent; t.textContent = LABEL; }
      });
    };
    const restore = () => buttons().forEach((b) => {
      const t = textNode(b);
      if (t && b.dataset.ltText && t.textContent.trim() === LABEL) t.textContent = b.dataset.ltText;
    });
    const ask = (event) => {
      if (fieldset.dataset.ltChoose !== 'pending') return;
      const b = event.target.closest('button[name=add], .sticky-add-to-cart__button');
      if (event.type === 'click' && !b) return;
      if (event.type === 'submit' && !main.contains(event.target)) return;
      if (b && b.closest('dialog')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      fieldset.classList.add('lt-size-needed');
      fieldset.scrollIntoView({ block: 'center', behavior: 'smooth' });
      (radios.find((r) => r.dataset.optionAvailable !== 'false') || radios[0]).focus({ preventScroll: true });
    };
    document.addEventListener('click', ask, true);
    document.addEventListener('submit', ask, true);
    fieldset.addEventListener('change', () => {
      fieldset.dataset.ltChoose = 'done';
      fieldset.classList.remove('lt-size-needed');
      restore();
    });
    label();
    document.addEventListener('variant:update', () => setTimeout(label, 0));
    new MutationObserver(label).observe(main, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();

/* LT Club: Escape con la guía de tallas abierta cierra solo la guía, no la compra rápida */
window.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const guide = [...document.querySelectorAll('dialog.lt-size-dialog[open]')].pop();
  if (!guide) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  guide.close();
}, true);

/* LT Club: accesibilidad y enlaces (título del pase de portada, contadores, logo, comparativa, garantía) */
(() => {
  function fix() {
    document.querySelectorAll('.slideshow-section h2.visually-hidden').forEach((h) => {
      if (/diapositiva/i.test(h.textContent)) h.textContent = 'LT Après Ski Club: lo destacado';
    });
    document.querySelectorAll('.lt-count:not([data-count])').forEach((el) => {
      el.dataset.count = el.textContent.trim();
      el.textContent = '';
    });
    document.querySelectorAll('a.header-logo').forEach((a) => {
      if (!a.textContent.trim() && !a.getAttribute('aria-label') && !a.querySelector('img[alt]:not([alt=""])')) a.setAttribute('aria-label', 'LT Après Ski Club, inicio');
    });
    const seo = document.querySelector('.lt-cseo');
    const h1 = document.querySelector('#MainContent h1');
    if (seo && h1 && /\/collections\/sudaderas/.test(location.pathname) && !document.querySelector('.lt-compare-link')) {
      const target = [...seo.querySelectorAll('h3')].find((h) => /qué modelo elegir/i.test(h.textContent));
      if (target) {
        target.id = 'que-modelo-elegir';
        const link = document.createElement('a');
        link.className = 'lt-compare-link';
        link.href = '#que-modelo-elegir';
        link.textContent = 'Cabin, Summit, Sunfade… compara los modelos ↓';
        h1.closest('.text-block')?.insertAdjacentElement('afterend', link);
      }
    }
    if (/\/pages\/devoluciones/.test(location.pathname)) {
      const g = [...document.querySelectorAll('#MainContent h2, #MainContent h3')].find((h) => /garant/i.test(h.textContent));
      if (g && !document.getElementById('garantia')) g.id = 'garantia';
      if (location.hash === '#garantia' && g) g.scrollIntoView();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
  document.addEventListener('shopify:section:load', fix);
})();

/* LT Club: la cinta de avisos tiene una sola parada de teclado y se lee una vez */
(() => {
  function tidy() {
    const bar = document.querySelector('.announcement-bar.lt-has-marquee');
    if (!bar || bar.dataset.ltTidy) return;
    bar.dataset.ltTidy = '1';
    bar.querySelectorAll('.announcement-bar__slide').forEach((slide) => slide.setAttribute('aria-hidden', 'true'));
    const links = [...bar.querySelectorAll('a')];
    links.forEach((a) => { a.tabIndex = -1; a.setAttribute('aria-hidden', 'true'); });
    const first = bar.querySelector('.lt-marquee__track a');
    if (!first) return;
    const texts = [...new Set(links.filter((a) => a.closest('.lt-marquee')).map((a) => a.textContent.trim()).filter(Boolean))];
    first.removeAttribute('tabindex');
    first.removeAttribute('aria-hidden');
    first.setAttribute('aria-label', texts.join(' · ').toLowerCase().replace(/^./, (c) => c.toUpperCase()));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(tidy, 0));
  else setTimeout(tidy, 0);
})();

/* LT Club: /collections/all se titula «Toda la colección» */
(() => {
  const rename = () => {
    if (!/^\/collections\/all\/?$/.test(location.pathname)) return;
    const h1 = document.querySelector('#MainContent h1');
    if (h1 && h1.textContent.trim() === 'Productos') h1.textContent = 'Toda la colección';
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rename);
  else rename();
})();
